import { CmsStatusEnum } from "dash-common";

export interface CmsActionButtonsProps {
  propertyId: string;
  currentStatus?: CmsStatusEnum | null;
  onStatusChange?: () => void;
}

export type ActionType = 'approve' | 'audit' | 'archive';

export interface ActionConfig {
  title: string;
  message: string;
  buttonLabel: string;
  loadingLabel: string;
  successMessage: string;
  errorMessage: string;
  colorVariation: 'success' | 'danger';
  canPerform: (status: CmsStatusEnum) => boolean;
}

export const ACTION_CONFIGS: Record<ActionType, ActionConfig> = {
  approve: {
    title: 'approveProperty',
    message: 'approvePropertyConfirmation',
    buttonLabel: 'approve',
    loadingLabel: 'approving',
    successMessage: 'propertyApprovedSuccess',
    errorMessage: 'propertyApprovedError',
    colorVariation: 'success',
    canPerform: (status) => status === CmsStatusEnum.PENDING_APPROVAL,
  },
  audit: {
    title: 'auditProperty',
    message: 'auditPropertyConfirmation',
    buttonLabel: 'audit',
    loadingLabel: 'auditing',
    successMessage: 'propertyAuditedSuccess',
    errorMessage: 'propertyAuditedError',
    colorVariation: 'success',
    canPerform: (status) => status === CmsStatusEnum.AWAITING_AUDIT,
  },
  archive: {
    title: 'archiveProperty',
    message: 'archivePropertyConfirmation',
    buttonLabel: 'archive',
    loadingLabel: 'archiving',
    successMessage: 'propertyArchivedSuccess',
    errorMessage: 'propertyArchivedError',
    colorVariation: 'danger',
    canPerform: (status) => status === CmsStatusEnum.PENDING_ARCHIVE,
  },
};

// Default fallback messages in case translations are missing
export const DEFAULT_MESSAGES: Record<string, string> = {
  approveProperty: "Approve Property",
  approvePropertyConfirmation: "Are you sure you want to approve this property? This will make it visible as a new listing and eventually transition to active.",
  approve: "Approve",
  approving: "Approving...",
  propertyApprovedSuccess: "Property has been approved successfully",
  propertyApprovedError: "Failed to approve property",
  auditProperty: "Audit Property",
  auditPropertyConfirmation: "Mark this property as audited? This confirms the information has been reviewed and is accurate.",
  audit: "Audit",
  auditing: "Auditing...",
  propertyAuditedSuccess: "Property has been audited successfully",
  propertyAuditedError: "Failed to audit property",
  archiveProperty: "Archive Property",
  archivePropertyConfirmation: "Are you sure you want to archive this property? This will hide it from public view and mark it as archived.",
  archive: "Archive",
  archiving: "Archiving...",
  propertyArchivedSuccess: "Property has been archived successfully",
  propertyArchivedError: "Failed to archive property",
  cancel: "Cancel",
};